<template>
  <div class="page-invoice-detail">
    <div class="content">
      <div class="header"></div>
      <div class="container">
        <!-- 状态栏 -->
        <div class="invoice-status">
          <h2 class="status">{{ invoiceStatus ? '发票已开具' : '发票开具中' }}</h2>
          <span class="status-description">如若发票开具错误，请及时联系客服。</span>
        </div>
        <!-- 发票抬头 -->
        <div v-if="invoice.headerVO" class="invoice-info panel">
          <div class="line">
            <span class="label" style="width: 90px">开票方式</span>
            <span class="value">{{ invoice.invoiceWay == 'PAPER' ? '纸质发票' : '电子发票' }}</span>
          </div>
          <div class="line">
            <span class="label" style="width: 90px">发票抬头</span>
            <span class="value">{{ invoice.headerVO.invoiceType == 'COMPANY' ? '公司' : '个人' }}</span>
          </div>
          <div class="line">
            <span class="label" style="width: 90px">
              {{ invoice.headerVO.invoiceType == 'COMPANY' ? '公司名称' : '个人名称' }}
            </span>
            <span class="value">
              {{
                invoice.headerVO.invoiceType == 'COMPANY' ? invoice.headerVO.companyName : invoice.headerVO.personName
              }}
            </span>
          </div>
          <div v-if="invoice.headerVO.invoiceType == 'COMPANY'" class="line">
            <span class="label" style="width: 90px">纳税人识别号</span>
            <span class="value">{{ invoice.headerVO.invoiceTaxNum }}</span>
          </div>
          <div class="line">
            <span class="label" style="width: 90px">邮箱/手机</span>
            <span class="value">{{ invoice.headerVO.emailOrPhone }}</span>
          </div>
        </div>
        <template v-if="invoiceStatus">
          <!-- 发票信息 -->
          <div v-if="invoice.invoiceWay == 'PAPER'" class="invoice-info panel">
            <h3 class="title">纸质发票</h3>
            <template v-for="(paper, index) in invoice.paperItems">
              <div class="col underline-custom" :key="index">
                <div class="label">
                  {{ `发票${index + 1}${paper.validFlag ? '' : '(已作废)'}` }}
                  {{ paper.alongWithGoods ? '：随货同行' : '' }}
                </div>
                <div v-if="paper.companyCode" class="label">快递公司：{{ paper.companyCode }}</div>
                <div v-if="paper.expressNo" class="flex space-between">
                  <span class="label">快递单号：{{ paper.expressNo }}</span>
                  <button
                    class="btn-copy van-hairline--surround"
                    :ref="`copy${index}`"
                    :data-clipboard-text="paper.expressNo"
                  >
                    复制
                  </button>
                </div>
                <div v-if="paper.credentials" style="margin-top: 12px" class="flex-img" @click="handlePreview(paper)">
                  <div v-if="!paper.validFlag" class="custom-bg">已作废</div>
                  <img
                    class="van-img-custom"
                    style="cursor: pointer; border: 1px solid #d9d9d9; background: #eeeeee"
                    v-if="new RegExp('.(PDF|pdf)').test(paper.credentials)"
                    :src="require(`@/assets/imgs/pdf.svg`)"
                  />
                  <van-image v-else fit="cover" class="van-img-custom" :src="paper.credentials" />
                </div>
              </div>
            </template>
          </div>
          <div v-else class="invoice-info panel">
            <h3 class="title">电子发票</h3>
            <div
              class="flex space-between line underline link-list"
              v-for="(link, index) in invoice.links"
              :key="index"
            >
              <div class="label van-ellipsis" style="max-width: 250px">
                <span>{{ `发票${index + 1}${link.validFlag ? '' : '(已作废)'}:` }}</span>
                <span>
                  {{ link.link }}
                </span>
              </div>
              <button class="btn-copy van-hairline--surround" :ref="`link${index}`" :data-clipboard-text="link.link">
                复制
              </button>
            </div>
            <div class="flex no-shrink img-list">
              <div
                v-for="(img, index) in invoice.imgs"
                :key="index"
                class="flex-img"
                @click="handlePreview(img, invoice.imgs)"
              >
                <div v-if="!img.validFlag" class="custom-bg">已作废</div>
                <img
                  class="van-img-custom"
                  style="cursor: pointer; background: #eeeeee"
                  v-if="new RegExp('.(PDF|pdf)').test(img.imgUrl)"
                  :src="require(`@/assets/imgs/pdf.svg`)"
                />
                <van-image v-else fit="cover" class="van-img-custom" :src="img.imgUrl" />
              </div>
            </div>
          </div>
        </template>
        <div class="tip">提示：若无法打开链接，请复制链接至浏览器</div>
      </div>
    </div>
  </div>
</template>

<script>
// import pdf from 'vue-pdf-signature';
// import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory.js';
import { ImagePreview } from '@zyf2e/capui-mobile';
import Clipboard from 'clipboard';
export default {
  // components: { pdf },
  data() {
    return {
      invoice: {
        orderSn: '',
        sourceOrderSn: '',
        headerVO: {},
        invoiceWay: '',
        electronicType: '',
        links: [],
        imgs: [],
        paperItems: []
      }
    };
  },
  computed: {
    invoiceStatus() {
      return this.$route.query.status == 'ISSUED';
    },
    orderSn() {
      return this.$route.params.id;
    }
  },
  created() {
    this.getInvoiceDetail();
  },

  methods: {
    initClipBoard() {
      for (let ref in this.$refs) {
        var patt = /copy/;
        var pattLink = /link/;
        if (patt.test(ref) || pattLink.test(ref)) {
          const clipboard = new Clipboard(this.$refs[ref][0]);
          clipboard.on('success', (e) => {
            this.$toast('复制成功');
            e.clearSelection();
          });
        }
      }
    },
    async getInvoiceDetail() {
      let data = await this.$fetch.getInvoiceDetail({ sourceOrderSn: this.orderSn });
      this.invoice = data;
      this.$nextTick(() => {
        this.initClipBoard();
      });
    },
    handlePreview(img, imgs) {
      let url = img.imgUrl || img.credentials;
      let flag = new RegExp('.(PDF|pdf)').test(url);
      if (flag) {
        window.location.href = url;
        return;
      }
      if (!imgs) {
        ImagePreview({
          images: [url],
          startPosition: 0,
          closeable: true
        });
        return;
      }
      let imglist = imgs
        .filter((cur) => {
          let curUrl = cur.imgUrl || cur.credentials;
          return !new RegExp('.(PDF|pdf)').test(curUrl);
        })
        .map((cur) => {
          let curUrl = cur.imgUrl || cur.credentials;
          return curUrl;
        });
      let index = imglist.findIndex((curUrl) => {
        return curUrl == url;
      });
      ImagePreview({
        images: imglist,
        startPosition: index,
        closeable: true
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-invoice-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .panel {
    background: #fff;
    padding: 16px 12px;
    border-radius: 8px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    margin: 8px 0;
  }
  .col {
    .label {
      height: 20px;
      font-size: 14px;
      color: #8c8c8c;
      line-height: 20px;
    }
    .btn-copy {
      position: relative;
      width: 56px;
      height: 24px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #d9d9d9;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      flex: 0 0 auto;
      border: none;
      margin-left: 12px;
      &.van-hairline--surround::after {
        border-radius: 24px;
      }
    }
  }

  .underline {
    position: relative;
    &::after {
      position: absolute;
      width: 100%;
      bottom: 0;
      content: '';
      display: block;
      height: 1px;
      transform: scaleY(0.5);
      background: #eeeeee;
    }
  }
  .underline-custom {
    position: relative;
    padding-bottom: 12px;
    & + .underline-custom::before {
      position: absolute;
      width: 100%;
      top: -8px;
      content: '';
      display: block;
      height: 1px;
      transform: scaleY(0.5);
      background: #eeeeee;
    }
  }
  .line {
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;
    .label {
      // width: 90px;
      font-size: 14px;
      color: #8c8c8c;
      flex: 0 0 auto;
    }
    .value {
      font-size: 14px;
      line-height: 21px;
      color: #262626;
      flex: 1 1 auto;
    }
    .btn-copy {
      position: relative;
      width: 56px;
      height: 24px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #d9d9d9;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      flex: 0 0 auto;
      border: none;
      margin-left: 12px;
      &.van-hairline--surround::after {
        border-radius: 24px;
      }
    }
  }
  .img {
    width: 80px;
    margin: 0 auto 20px;
  }
  .invoice-info {
    padding: 12px;
    margin: 12px;
  }
  .content {
    position: relative;
    padding-top: 28px;
    flex: 1 1 auto;
    height: 400px;
    overflow: auto;
    .header {
      position: absolute;
      z-index: 1;
      top: -28px;
      width: 100%;
      height: 235px;
      background: linear-gradient(180deg, #1e8dff 0%, #1e8dff 50%, rgba(30, 141, 255, 0) 100%);
      // background: linear-gradient(180deg, #1e8dff 0%, rgba(30, 141, 255, 0) 100%);
    }
    .container {
      position: relative;
      z-index: 2;
    }
    .invoice-status {
      .status {
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        margin: 0 0 8px 24px;
      }
      .status-description {
        display: block;
        font-size: 14px;
        color: #ffffff;
        line-height: 14px;
        margin: 0 0 24px 24px;
      }
    }
  }
  .no-shrink {
    flex-shrink: 0;
    flex-wrap: wrap;
  }
  .flex-img {
    position: relative;
    width: 76px;
    height: 76px;
    margin-right: 4px;
    margin-bottom: 4px;
  }
  .link {
    color: #1e8dff;
    text-decoration: underline;
  }
  .link-list + .img-list {
    margin-top: 24px;
  }
  .custom-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 14px;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
    text-align: center;
    line-height: 78px;
    cursor: pointer;
    z-index: 1000;
    border-radius: 8px;
  }
  .van-img-custom {
    z-index: 100;
    width: 76px;
    height: 76px;
    border-radius: 8px;
    /deep/ canvas {
      border-radius: 8px;
    }
  }
  /deep/.van-image__img {
    width: 74px;
    height: 74px;
    box-sizing: content-box;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
  }
  /deep/.van-image__error {
    border-radius: 8px;
  }
  .tip {
    margin: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 12px;
  }
}
</style>
